<template lang="slm">
.SearchBox.IssuesSearchBox.Typeahead
  .container.SearchBox-container.IssueSearchBox-container
    .columns.is-multiline
      .column.is-12.
        .SearchBox-content
            h3.title.SearchBox-heading.has-text-centered v-if="title === 'Forsiden'"
              | Finn saker du er opptatt av
            h3.title.SearchBox-heading.has-text-centered v-else=""
              | Finn
              a href="/politikken#saker" saker
              | du er opptatt av
      .column.is-6.is-offset-3
        .IssueSearchResult
          input#Typed.Typeahead-input.typeahead.tt-input type="text" autocomplete="off" v-model="term" v-on:blur="inputFocus = false" v-on:focus="inputFocus = true" ref="Typed"
          transition name="fade"
            .tt-menu v-show="foundIssues.length > 0 && inputFocus"
              .tt-dataset.tt-dataset-issues
                .IssuesSearchBox-item.tt-suggestion.tt-selectable(
                  v-for="issue in foundIssues"
                  v-on:click="$router.push(issue.slug.current)") {{issue.title}}
</template>

<script>
import sanityQuery from '@/sanityQuery'

require('@/assets/typed.min.js')

export default {
  data () {
    return {
      title: 'Forsiden',
      term: '',
      foundIssues: [],
      inputFocus: true
    }
  },
  mounted () {
    this.getPlaceholderIssues()
  },
  watch: {
    term: function (term) {
      if (term !== '') {
        var query = `*[_type == "issue" && title match [${term.split(/\s+/).map(s => `"${s}*"`)}]] | order(name) [0...500]{title, slug}`
        sanityQuery(query)
          .then((result) => {
            this.foundIssues = (result)
          })
      } else {
        this.foundIssues = []
      }
    }
  },
  methods: {
    getPlaceholderIssues () {
      var query = `*[_type == "issue" && !(_id in path "drafts.**")][0...500] | order(title asc){title}`
      sanityQuery(query)
        .then(result => {
          var placeholders = []
          result.map(i => placeholders.push(i.title))
          window.Typed.new('#Typed', {
            strings: placeholders,
            typeSpeed: 20,
            attr: 'placeholder',
            shuffle: true,
            loop: true,
            showCursor: true,
            backDelay: 2000
          })
        })
    }
  }
}
</script>

<style lang="css">
.IssueSearchResult {
  position: relative;
}
.tt-menu {
  position: absolute;
  top: 100%;
  left: 0px;
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/IssueSearch.vue